<ul>
  <li>
    <p style="margin-bottom: 10px;">
      <span style=""
        ><span style="color: #00b0f0;"><span style=""><span lang="en-GB"><strong>Target</strong></span></span></span><span
          style="color: #00b0f0;"><span style=""><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span style=""
            ><span lang="en-GB"
              >Target for the Customer Lifetime Value (CLV) in &euro; for the current month (if YTD is selected). If a previous year is
              selected as reporting timeframe: CLV target at the end of the selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p style="margin-bottom: 10px;">
      <span style=""
        ><span style="color: #404040;"><span style=""><span lang="en-GB"><strong>Actual</strong></span></span></span><span
          style="color: #404040;"
          ><span style=""
            ><span lang="en-GB"
              >: The actual CLV in &euro;. If a previous year is selected as reporting timeframe: Actual CLV at the end of the selected
              year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span style=""
        ><span style="color: #404040;"><span style=""><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"
          ><span style=""><span lang="en-GB">: The icon next to the CLV indicates, whether the target is met (</span></span></span
        ><span style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span style=""><span lang="en-GB">) or missed (</span></span></span
        ><span style="color: #ffc000;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span style=""><span lang="en-GB">)</span></span></span
        ></span
      >
    </p>
  </li>
</ul>
<p style="color: gray;">
  <em
    >Please note that the CLV of the previous month is shown, until invoicing is done for the current month. You can see the month of the
    CLV at the bottom of the box.</em
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p>Chart:</p>
<p>&nbsp; &nbsp; <img style="background-color: #00B0F0; height:2px; width: 11px;" />&nbsp; CLV target</p>
<p>
  &nbsp; &nbsp; <img style="background-color: #455f51; height:2px; width: 11px;" />&nbsp;&nbsp;&nbsp;Active boluses
  month-to-month/quarter-to-quarter connect-ion line
</p>
<p>&nbsp; CLV month-to-month/quarter-to-quarter connection line</p>
<p>
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNxjQ/8z4AHsOCTHFVAggIA4psCIYbRm1MAAAAASUVORK5CYII="
    alt=""
  />&nbsp; &nbsp;CLV of month / end of quarter / end of half-year
</p>
<p style="margin-bottom:10px;">
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp; &nbsp;CLV previous year
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }
</style>
